<template>
  <v-app>
    <Navigation v-bind:drawer="drawer" />
    <Toolbar v-bind:drawer="drawer" v-on:toogle-drawer="toogleDrawer" />
    <v-content class="force-padding-0">
      <Dashboard v-if="isDashboard" />
      <ClientList v-if="isClientRoute" />
      <CarList v-if="isCarRoute" />
    </v-content>
  </v-app>
</template>

<script>
import Navigation from "./components/mecanica/Navigation";
import Toolbar from "./components/mecanica/Toolbar";
import Dashboard from "./components/mecanica/Dashboard";
import ClientList from "./components/mecanica/ClientList";
import CarList from "./components/mecanica/CarList";
import pathToRegexp from 'path-to-regexp'

export default {
  name: "MecanicaApp",
  components: { Navigation, Toolbar, Dashboard, ClientList, CarList },
  data() {
    return {
      drawer: false
    };
  },
  created () {
    this.refreshToken({now: true})
    this.refresh_token_interval = setInterval(this.refreshToken({now: false}), 300000) // refresh each 5 minutes
  },
  mounted() {
    if (!this.logged) {
      this.$router.push({ path: '/sign_in' })
    }
  },
  computed: {
    logged() {
      return this.$cookies.isKey("api_token");
    },
    isCarRoute() {
      return this.checkRoute('/carros*')
    },
    isClientRoute() {
      return this.checkRoute('/cliente*')
    },
    isDashboard() {
      return (!this.isClientRoute && !this.isCarRoute);
    }
  },
  methods: {
    checkRoute(string_route) {
      return pathToRegexp(string_route).exec(this.$route.path) !== null;
    },
    toogleDrawer() {
      this.drawer = !this.drawer;
    },
    refreshToken ({now=false}) {
      let self = this
      let api_token = this.$cookies.get('api_token')

      let successCallback = (response) => {
        if (response.body.data && response.body.data == 'ok') {

          let expire_at = new Date((new Date).getTime() + 60*60000);

          self.$cookies.set('api_token', self.$cookies.get('api_token'), expire_at)
          self.$cookies.set('user_name', self.$cookies.get('user_name'), expire_at)
          self.$cookies.set('user_email', self.$cookies.get('user_email'), expire_at)
          self.$cookies.set('business_id', self.$cookies.get('business_id'), expire_at)
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      let doRequest = () => {
        if (api_token) {
          self.$http.get(`${this.$root.base_url}/refresh_token`, { headers: { Token: api_token } }).then(successCallback, errorCallback)
        }
      }

      if (now) {
        doRequest()
        return true
      } else {
        return doRequest
      }
    }
  },
  metaInfo: {
    title: "Mecânica Online",
    link: [
      {
        rel: "stylesheet",
        href:
          "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons"
      }
    ]
  }
};
</script>

<style>
  body {
    background-color: #fafafa;
  }
  .force-padding-0 {
    padding: 0px 0px 0px 0px!important;
  }
  .container-top-margin {
    margin-top: 60px!important;
    margin-bottom: -60px!important;
  }
</style>



// WEBPACK FOOTER //
// src/MecanicaApp.vue